module.exports = __webpack_public_path__ + "img/bgc.c9c72029.png";